import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaSf_2.mjs'
import FormChoose from '../SF_1/FormChooseSf_1.jsx'
import TableChoose from '../SF_1/TableChooseSf_1.jsx'
import api from './apiSf_2.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
